/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatientProfileDto } from './PatientProfileDto';
import {
    PatientProfileDtoFromJSON,
    PatientProfileDtoFromJSONTyped,
    PatientProfileDtoToJSON,
    PatientProfileDtoToJSONTyped,
} from './PatientProfileDto';
import type { PracticeProfileDto } from './PracticeProfileDto';
import {
    PracticeProfileDtoFromJSON,
    PracticeProfileDtoFromJSONTyped,
    PracticeProfileDtoToJSON,
    PracticeProfileDtoToJSONTyped,
} from './PracticeProfileDto';

/**
 * 
 * @export
 * @interface GoogleSignInRequest
 */
export interface GoogleSignInRequest {
    /**
     * Google ID token from OAuth flow
     * @type {string}
     * @memberof GoogleSignInRequest
     */
    idToken: string;
    /**
     * Type of user account
     * @type {string}
     * @memberof GoogleSignInRequest
     */
    userType: GoogleSignInRequestUserTypeEnum;
    /**
     * Platform (web/mobile)
     * @type {string}
     * @memberof GoogleSignInRequest
     */
    platform?: string;
    /**
     * Is sign up
     * @type {boolean}
     * @memberof GoogleSignInRequest
     */
    isSignUp?: boolean;
    /**
     * Practice details
     * @type {PracticeProfileDto}
     * @memberof GoogleSignInRequest
     */
    practiceProfile?: PracticeProfileDto;
    /**
     * Patient details
     * @type {PatientProfileDto}
     * @memberof GoogleSignInRequest
     */
    patientProfile?: PatientProfileDto;
}


/**
 * @export
 */
export const GoogleSignInRequestUserTypeEnum = {
    Patient: 'patient',
    Provider: 'provider',
    Admin: 'admin'
} as const;
export type GoogleSignInRequestUserTypeEnum = typeof GoogleSignInRequestUserTypeEnum[keyof typeof GoogleSignInRequestUserTypeEnum];


/**
 * Check if a given object implements the GoogleSignInRequest interface.
 */
export function instanceOfGoogleSignInRequest(value: object): value is GoogleSignInRequest {
    if (!('idToken' in value) || value['idToken'] === undefined) return false;
    if (!('userType' in value) || value['userType'] === undefined) return false;
    return true;
}

export function GoogleSignInRequestFromJSON(json: any): GoogleSignInRequest {
    return GoogleSignInRequestFromJSONTyped(json, false);
}

export function GoogleSignInRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSignInRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'idToken': json['idToken'],
        'userType': json['userType'],
        'platform': json['platform'] == null ? undefined : json['platform'],
        'isSignUp': json['isSignUp'] == null ? undefined : json['isSignUp'],
        'practiceProfile': json['practiceProfile'] == null ? undefined : PracticeProfileDtoFromJSON(json['practiceProfile']),
        'patientProfile': json['patientProfile'] == null ? undefined : PatientProfileDtoFromJSON(json['patientProfile']),
    };
}

export function GoogleSignInRequestToJSON(json: any): GoogleSignInRequest {
    return GoogleSignInRequestToJSONTyped(json, false);
}

export function GoogleSignInRequestToJSONTyped(value?: GoogleSignInRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idToken': value['idToken'],
        'userType': value['userType'],
        'platform': value['platform'],
        'isSignUp': value['isSignUp'],
        'practiceProfile': PracticeProfileDtoToJSON(value['practiceProfile']),
        'patientProfile': PatientProfileDtoToJSON(value['patientProfile']),
    };
}

